'use strict';

module.exports = require('./LM');
module.exports.Matrix = require('ml-matrix');
module.exports.Matrix.algebra = require('./algebra');



//////////////////
// WEBPACK FOOTER
// ./~/ml-optimize-lorentzian/~/ml-curve-fitting/src/index.js
// module id = 126
// module chunks = 0